<template>
  <g>
    <text transform="matrix(1 0 0 1 300 230)" class="name">함수발생기{{number}}</text>
    <g transform="scale(1.2)">
      <g>
        <path class="tool-border" d="M727.44,329.91H186.89c-12.63,0-22.86-10.24-22.86-22.86V113.26c0-12.63,10.24-22.86,22.86-22.86h540.54
          c12.63,0,22.86,10.24,22.86,22.86v193.79C750.3,319.67,740.06,329.91,727.44,329.91z"/>
      </g>
      <g>
        <path class="st1" d="M722.19,322.27H192.13c-11.15,0-20.19-9.04-20.19-20.19V118.24c0-11.15,9.04-20.19,20.19-20.19h530.06
          c11.15,0,20.19,9.04,20.19,20.19v183.84C742.39,313.23,733.35,322.27,722.19,322.27z"/>
      </g>
      <g>
        <path class="st2" d="M722.14,308.99H189.63c-2.43,0-4.39-1.97-4.39-4.39V115.71c0-2.43,1.97-4.39,4.39-4.39h532.51
          c2.43,0,4.39,1.97,4.39,4.39V304.6C726.54,307.02,724.57,308.99,722.14,308.99z"/>
      </g>
      <g>
        <path class="st3" d="M718.27,295.22H520.48c-1.51,0-2.73-1.22-2.73-2.73V119.73c0-1.51,1.22-2.73,2.73-2.73h197.78
          c1.51,0,2.73,1.22,2.73,2.73V292.5C720.99,294,719.77,295.22,718.27,295.22z"/>
      </g>
      <g>
        <circle class="st1" cx="647.37" cy="162.34" r="17.27"/>
        <path class="st4" d="M660.19,169.73L660.19,169.73c0.31-0.53,1.1-0.65,1.76-0.27l1.39,0.8c1.03-2.07,1.67-4.37,1.82-6.81h-1.58
          c-0.48,0-0.91-0.2-1.16-0.49c-0.16-0.18-0.26-0.4-0.26-0.64c0-0.61,0.62-1.11,1.39-1.11h1.6c-0.15-2.43-0.79-4.73-1.82-6.8
          l-1.38,0.8c-0.59,0.34-1.27,0.29-1.63-0.1c-0.06-0.06-0.11-0.12-0.15-0.19c-0.31-0.53-0.02-1.27,0.65-1.66l1.39-0.8
          c-0.66-0.99-1.41-1.9-2.24-2.74c-0.83-0.83-1.75-1.58-2.74-2.24l-0.8,1.39c-0.38,0.67-1.13,0.96-1.66,0.65
          c-0.07-0.04-0.13-0.09-0.19-0.15c-0.38-0.36-0.44-1.05-0.1-1.63l0.8-1.38c-2.07-1.03-4.37-1.67-6.8-1.82v1.6
          c0,0.77-0.5,1.39-1.11,1.39c-0.24,0-0.46-0.1-0.64-0.26c-0.3-0.25-0.49-0.67-0.49-1.16v-1.58c-2.44,0.15-4.74,0.8-6.81,1.83
          l0.79,1.36c0.38,0.67,0.26,1.45-0.27,1.76c-0.53,0.31-1.27,0.02-1.66-0.65l-0.79-1.36c-1.98,1.31-3.67,3.01-4.99,4.99l1.36,0.79
          c0.67,0.38,0.96,1.13,0.65,1.66s-1.1,0.65-1.76,0.27l-1.36-0.79c-1.03,2.07-1.68,4.38-1.83,6.81h1.58c0.77,0,1.39,0.5,1.39,1.11
          c0,0.61-0.62,1.11-1.39,1.11h-1.58c0.15,2.45,0.79,4.76,1.83,6.85l1.39-0.8c0.67-0.38,1.45-0.26,1.76,0.27
          c0.31,0.53,0.02,1.27-0.65,1.66l-1.39,0.8c0.33,0.49,0.68,0.97,1.05,1.42c0.01,0.01,0.02,0.03,0.03,0.04
          c0.17,0.2,0.34,0.4,0.51,0.59c0.05,0.05,0.1,0.1,0.14,0.15c0.14,0.15,0.28,0.3,0.43,0.45c0.08,0.08,0.15,0.15,0.23,0.23
          c0.12,0.12,0.24,0.23,0.36,0.35c0.1,0.09,0.2,0.18,0.31,0.28c0.1,0.09,0.2,0.18,0.31,0.26c0.13,0.11,0.25,0.21,0.38,0.31
          c0.08,0.06,0.16,0.13,0.24,0.19c0.15,0.12,0.31,0.24,0.47,0.35c0.05,0.04,0.11,0.07,0.16,0.11c0.13,0.09,0.26,0.17,0.38,0.26
          l0.8-1.38c0.38-0.67,1.13-0.96,1.66-0.65l0,0c0.53,0.31,0.65,1.1,0.27,1.76l-0.8,1.38c2.08,1.03,4.38,1.67,6.82,1.82v-1.58
          c0-0.77,0.5-1.39,1.11-1.39c0.61,0,1.11,0.62,1.11,1.39v1.58c2.43-0.15,4.73-0.79,6.81-1.83l-0.8-1.39
          c-0.38-0.67-0.26-1.45,0.27-1.76c0.4-0.23,0.93-0.12,1.33,0.24c0.13,0.12,0.25,0.26,0.35,0.43l0.79,1.36
          c1.98-1.31,3.67-3.01,4.99-4.99l-1.36-0.79c-0.17-0.1-0.31-0.22-0.43-0.35C660.07,170.67,659.95,170.14,660.19,169.73z"/>
        <circle class="st5" cx="647.37" cy="162.34" r="13.86"/>
      </g>
      <!-- Dial Button Group-->
      <g class="dial-group" transform="scale(1.15) translate(-70,-27)">
        <!-- Dial 7 -->
        <g class="valid" @click="pressDial('7')">
          <g>
            <path class="st6" d="M531.02,154.61c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H531.02z"/>
            <g>
              <path class="st0" d="M543.08,144.34c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01h-12.06
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H543.08 M543.08,143.84h-12.06c-3.04,0-5.51,2.47-5.51,5.51
                c0,3.04,2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S546.11,143.84,543.08,143.84L543.08,143.84z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 535 152)" class="st7 st8 st9">7</text>
          </g>
        </g>
        <!-- Dial 4 -->
        <g class="valid" @click="pressDial('4')">
          <g>
            <path class="st6" d="M531.02,171.41c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H531.02z"/>
            <g>
              <path class="st0" d="M543.08,161.15c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01h-12.06c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H543.08 M543.08,160.65h-12.06c-3.04,0-5.51,2.47-5.51,5.51s2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51S546.11,160.65,543.08,160.65L543.08,160.65z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 535 169)" class="st7 st8 st9">4</text>
          </g>
        </g>
        <!-- Dial 1 -->
        <g class="valid" @click="pressDial('1')">
          <g>
            <path class="st6" d="M531.02,188.22c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H531.02z"/>
            <g>
              <path class="st0" d="M543.08,177.95c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01h-12.06c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H543.08 M543.08,177.45h-12.06c-3.04,0-5.51,2.47-5.51,5.51c0,3.04,2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51C548.59,179.93,546.11,177.45,543.08,177.45L543.08,177.45z"/>
            </g>
          </g>
          <text transform="matrix(1 0 0 1 535 186)" class="st7 st8 st9">1</text>
        </g>
        <!-- Dial 0 -->
        <g class="valid" @click="pressDial('0')">
          <g>
            <path class="st6" d="M531.02,205.03c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H531.02z"/>
            <g>
              <path class="st0" d="M543.08,194.76c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01h-12.06
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H543.08 M543.08,194.26h-12.06c-3.04,0-5.51,2.47-5.51,5.51
                s2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S546.11,194.26,543.08,194.26L543.08,194.26z"/>
            </g>
          </g>
          <text transform="matrix(1 0 0 1 535 203)" class="st7 st8 st9">0</text>
        </g>
        <!-- Dial 8 -->
        <g class="valid" @click="pressDial('8')">
          <g>
            <path class="st6" d="M561.5,154.61c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H561.5z"/>
            <g>
              <path class="st0" d="M573.56,144.34c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01H561.5
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H573.56 M573.56,143.84H561.5c-3.04,0-5.51,2.47-5.51,5.51
                c0,3.04,2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S576.6,143.84,573.56,143.84L573.56,143.84z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 566 152)" class="st7 st8 st9">8</text>
          </g>
        </g>
        <!-- Dial 5 -->
        <g class="valid" @click="pressDial('5')">
          <g>
            <path class="st6" d="M561.5,171.41c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H561.5z"/>
            <g>
              <path class="st0" d="M573.56,161.15c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01H561.5c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H573.56 M573.56,160.65H561.5c-3.04,0-5.51,2.47-5.51,5.51s2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51S576.6,160.65,573.56,160.65L573.56,160.65z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 566 169)" class="st7 st8 st9">5</text>
          </g>
        </g>
        <!-- Dial 2 -->
        <g class="valid" @click="pressDial('2')">
          <g>
            <path class="st6" d="M561.5,188.22c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H561.5z"/>
            <g>
              <path class="st0" d="M573.56,177.95c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01H561.5c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H573.56 M573.56,177.45H561.5c-3.04,0-5.51,2.47-5.51,5.51c0,3.04,2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51C579.07,179.93,576.6,177.45,573.56,177.45L573.56,177.45z"/>
            </g>
          </g>
          <text transform="matrix(1 0 0 1 566 186)" class="st7 st8 st9">2</text>
        </g>
        <!-- Dial . -->
        <g class="valid" @click="pressDial('.')">
          <g>
            <path class="st6" d="M561.5,205.03c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H561.5z"/>
            <g>
              <path class="st0" d="M573.56,194.76c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01H561.5
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H573.56 M573.56,194.26H561.5c-3.04,0-5.51,2.47-5.51,5.51
                s2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S576.6,194.26,573.56,194.26L573.56,194.26z"/>
            </g>
          </g>
          <text transform="matrix(1 0 0 1 567 200)" class="st7 st8 st10">.</text>
        </g>
        <!-- Dial 9 -->
        <g class="valid" @click="pressDial('9')">
          <g>
            <path class="st6" d="M591.98,154.61c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H591.98z"/>
            <g>
              <path class="st0" d="M604.04,144.34c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01h-12.06
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H604.04 M604.04,143.84h-12.06c-3.04,0-5.51,2.47-5.51,5.51
                c0,3.04,2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S607.08,143.84,604.04,143.84L604.04,143.84z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 596 152)" class="st7 st8 st9">9</text>
          </g>
        </g>
        <!-- Dial 6 -->
        <g class="valid" @click="pressDial('6')">
          <g>
            <path class="st6" d="M591.98,171.41c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H591.98z"/>
            <g>
              <path class="st0" d="M604.04,161.15c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01h-12.06c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H604.04 M604.04,160.65h-12.06c-3.04,0-5.51,2.47-5.51,5.51s2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51S607.08,160.65,604.04,160.65L604.04,160.65z"/>
            </g>
          </g>
          <g>
            <text transform="matrix(1 0 0 1 596 169)" class="st7 st8 st9">6</text>
          </g>
        </g>
        <!-- Dial 3 -->
        <g class="valid" @click="pressDial('3')">
          <g>
            <path class="st6" d="M591.98,188.22c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H591.98z"/>
            <g>
              <path class="st0" d="M604.04,177.95c2.75,0,5.01,2.25,5.01,5.01s-2.25,5.01-5.01,5.01h-12.06c-2.75,0-5.01-2.25-5.01-5.01
                s2.25-5.01,5.01-5.01H604.04 M604.04,177.45h-12.06c-3.04,0-5.51,2.47-5.51,5.51c0,3.04,2.47,5.51,5.51,5.51h12.06
                c3.04,0,5.51-2.47,5.51-5.51C609.55,179.93,607.08,177.45,604.04,177.45L604.04,177.45z"/>
            </g>
          </g>
          <text transform="matrix(1 0 0 1 596 186)" class="st7 st8 st9">3</text>
        </g>
        <!-- Dial +/- -->
        <g class="valid" @click="pressDial('RESET')">
          <g>
            <path class="st6" d="M591.98,205.03c-2.9,0-5.26-2.36-5.26-5.26s2.36-5.26,5.26-5.26h12.06c2.9,0,5.26,2.36,5.26,5.26
              s-2.36,5.26-5.26,5.26H591.98z"/>
            <g>
              <path class="st0" d="M604.04,194.76c2.75,0,5.01,2.25,5.01,5.01v0c0,2.75-2.25,5.01-5.01,5.01h-12.06
                c-2.75,0-5.01-2.25-5.01-5.01v0c0-2.75,2.25-5.01,5.01-5.01H604.04 M604.04,194.26h-12.06c-3.04,0-5.51,2.47-5.51,5.51
                s2.47,5.51,5.51,5.51h12.06c3.04,0,5.51-2.47,5.51-5.51S607.08,194.26,604.04,194.26L604.04,194.26z"/>
            </g>
          </g>
          <text class="st7 st8" style="font-size: 6px;" transform="matrix(1 0 0 1 590 202.5)">RESET</text>
        </g>
      </g>
      <g>
        <path class="st12" d="M708.25,157.78h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C714.97,154.76,711.94,157.78,708.25,157.78z"/>
        <g>
          <text transform="matrix(0.95 0 0 1 689.7366 153.2568)" class="st13 st8 st14">Inter CH</text>
        </g>
      </g>
      <g>
        <path class="st12" d="M708.25,180.13h-16.18c-3.69,0-6.72-3.02-6.72-6.72l0,0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72l0,0C714.97,177.11,711.94,180.13,708.25,180.13z"/>
        <g>
          <text transform="matrix(0.95 0 0 1 693.0389 175.5587)" class="st13 st8 st14">Utility</text>
        </g>
      </g>
      <!-- Change Channel 1/2 -->
      <g class="valid" @click="changeChannel()">
        <path :class="{'st12': !on, 'light-on': on}" d="M556.21,236.45h-11.36c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h11.36
          c3.69,0,6.72,3.02,6.72,6.72v0C562.93,233.43,559.91,236.45,556.21,236.45z"/>
        <g>
          <text transform="matrix(0.95 0 0 1 542.3801 231.8749)" class="st13 st8 st14">Ch 1/2</text>
        </g>
      </g>
      <!-- Both Dial -->
      <g class="invalid">
        <path class="st12" d="M556.21,256.36h-11.36c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h11.36
          c3.69,0,6.72,3.02,6.72,6.72v0C562.93,253.34,559.91,256.36,556.21,256.36z"/>
        <g>
          <text transform="matrix(0.95 0 0 1 544.5578 251.7895)" class="st13 st8 st14">Both</text>
        </g>
      </g>
      <!-- Mod Dial -->
      <g>
        <path class="st15" d="M556.21,275.28h-11.36c-3.69,0-6.72-3.02-6.72-6.72l0,0c0-3.69,3.02-6.72,6.72-6.72h11.36
          c3.69,0,6.72,3.02,6.72,6.72l0,0C562.93,272.25,559.91,275.28,556.21,275.28z"/>
        <g>
          <text transform="matrix(0.95 0 0 1 544.8625 270.7041)" class="st13 st8 st14">Mod</text>
        </g>
      </g>
      <g>
        <path class="st12" d="M708.25,202.49h-16.18c-3.69,0-6.72-3.02-6.72-6.72v0c0-3.69,3.02-6.72,6.72-6.72h16.18
          c3.69,0,6.72,3.02,6.72,6.72v0C714.97,199.46,711.94,202.49,708.25,202.49z"/>
        <text transform="matrix(0.95 0 0 1 694.392 197.6111)" class="st13 st8 st14">Help</text>
      </g>
      <g>
        <path class="st16" d="M626.18,235.34h-13.72c-3.11,0-5.63-2.52-5.63-5.63v0c0-3.11,2.52-5.63,5.63-5.63h13.72
          c3.11,0,5.63,2.52,5.63,5.63v0C631.81,232.82,629.29,235.34,626.18,235.34z"/>
        <text transform="matrix(0.95 0 0 1 610.9185 231.7058)" class="st13 st8 st14">On/Off</text>
      </g>
      <g>
        <path class="st17" d="M683.98,235.34h-13.72c-3.11,0-5.63-2.52-5.63-5.63v0c0-3.11,2.52-5.63,5.63-5.63h13.72
          c3.11,0,5.63,2.52,5.63,5.63v0C689.61,232.82,687.09,235.34,683.98,235.34z"/>
        <text transform="matrix(0.95 0 0 1 668.7197 231.7058)" class="st13 st8 st14">On/Off</text>
      </g>
      <!-- Cursor Left -->
      <g class="valid" @click="moveFloating(-1)">
        <path class="st12" d="M644.99,202.49h-9.95c-2.95,0-5.35-2.41-5.35-5.35l0,0c0-2.95,2.41-5.35,5.35-5.35h9.95
          c0.62,0,1.13,0.51,1.13,1.13v8.45C646.12,201.98,645.62,202.49,644.99,202.49z"/>
        <g>
          <path class="st13" d="M640.99,200.31l-5.68-3.16l5.68-3.21V200.31z"/>
        </g>
      </g>
      <!-- Cursor right -->
      <g class="valid" @click="moveFloating(1)">
        <path class="st12" d="M649.41,191.78h9.95c2.95,0,5.35,2.41,5.35,5.35l0,0c0,2.95-2.41,5.35-5.35,5.35h-9.95
          c-0.62,0-1.13-0.51-1.13-1.13v-8.45C648.28,192.28,648.79,191.78,649.41,191.78z"/>
        <g>
          <path class="st13" d="M653.41,193.95l5.68,3.16l-5.68,3.21V193.95z"/>
        </g>
      </g>
      <g>
        <rect x="485.66" y="279.3" transform="matrix(6.123234e-17 -1 1 6.123234e-17 212.8459 780.8853)" class="st18" width="22.41" height="9.45"/>
        <rect x="491.58" y="282.91" transform="matrix(6.123234e-17 -1 1 6.123234e-17 216.4629 784.5023)" class="st19" width="17.8" height="2.21"/>
        <g>
          <g>
            <circle class="st20" cx="483.41" cy="276.19" r="1.07"/>
            <circle class="st20" cx="483.41" cy="292.3" r="1.39"/>
            <circle class="st20" cx="481.42" cy="281.32" r="1.07"/>
            <path class="st20" d="M483.22,288.74v0.38c-1.57,0-1.99-1.38-1.99-2.11v-5.42h0.38V287
              C481.61,287.07,481.64,288.74,483.22,288.74z"/>
            <g>
              <circle class="st20" cx="485.42" cy="279.56" r="1.07"/>
              <path class="st20" d="M485.61,279.82v3.91c0,0.73-0.42,2.11-1.99,2.11v-0.38c1.58,0,1.61-1.67,1.61-1.74v-3.91H485.61z"/>
            </g>
            <rect x="483.22" y="276.19" class="st20" width="0.38" height="16.11"/>
          </g>
        </g>
      </g>
      <g>
      <g>
        <text transform="matrix(1.1078 0 0 1 292.9151 126.5279)" class="st21 st22 st23">AFG1022</text>
      </g>
      <g>
        <text transform="matrix(1.1078 0 0 1 223.8608 126.1226)" class="st24 st22 st23">Tektronix</text>
      </g>
      <g>
        <text transform="matrix(0.9 0 0 1 357.3654 122.2683)"><tspan x="0" y="0" class="st21 st25 st26">APBITARY FUNCTUON</tspan><tspan x="0" y="4.55" class="st21 st25 st26">GENERATOR</tspan></text>
      </g>
      <path class="st24" d="M468.43,131.93h-36.91l15.42-18.72h21.49c2.16,0,3.91,1.75,3.91,3.91v10.89
        C472.34,130.18,470.59,131.93,468.43,131.93z"/>
      <path class="st27" d="M468.43,131.93H222.05c-2.16,0-3.91-1.75-3.91-3.91v-10.89c0-2.16,1.75-3.91,3.91-3.91h246.38
        c2.16,0,3.91,1.75,3.91,3.91v10.89C472.34,130.18,470.59,131.93,468.43,131.93z"/>
      </g>
      <!-- Display Pannel -->
      <g class="display">
        <path class="st28" d="M466.87,274.72H223.91c-3.19,0-5.78-2.59-5.78-5.78V145.96c0-3.19,2.59-5.78,5.78-5.78h242.96
        c3.19,0,5.78,2.59,5.78,5.78v122.99C472.65,272.14,470.06,274.72,466.87,274.72z"/>
        <g v-if="on" class="contents">
          <rect x="220" y="142" width="251" height="33" fill="blue" rx="5" ry="5"> </rect>
          <text transform="matrix(1 0 0 1 230 165)" style="font-family: sans-serif; font-size: 20px; fill: white;">
            {{ info.ch.toUpperCase() }}
          </text>
           <text transform="matrix(1 0 0 1 330 153)" style="font-family: sans-serif; font-size: 10px; fill: white;">
            Frequency
          </text>
           <text transform="matrix(1 0 0 1 300 169)" style="font-family: sans-serif; font-size: 15px; fill: white;">
            {{ info.freq.val }}
          </text>
           <text transform="matrix(1 0 0 1 390 169)" style="font-family: sans-serif; font-size: 15px; fill: white;">
            {{ info.freq.unit }}
          </text>
        </g>
      </g>
      <!-- Option Dials -->
      <g>
        <g class="valid" @click="displayMenu()">
          <path :class="{'st29': !on, 'light-on': on}" d="M499.1,172.4h-11.6c-1.37,0-2.49-1.12-2.49-2.49v-6.18c0-1.37,1.12-2.49,2.49-2.49h11.6
            c1.37,0,2.49,1.12,2.49,2.49v6.18C501.59,171.28,500.47,172.4,499.1,172.4z"/>
          <rect x="472.64" y="164.97" class="st30" width="9.59" height="3.71"/>
        </g>
        <g class="valid" @click="setFunction('FREQ')">
          <rect x="472.64" y="185.61" class="st30" width="9.59" height="3.71"/>
          <path :class="{'st29': !on, 'light-on': on}" d="M499.1,193.04h-11.6c-1.37,0-2.49-1.12-2.49-2.49v-6.18c0-1.37,1.12-2.49,2.49-2.49h11.6
            c1.37,0,2.49,1.12,2.49,2.49v6.18C501.59,191.92,500.47,193.04,499.1,193.04z"/>
        </g>
        <g class="valid" @click="setFunction('AMPL')">
          <rect x="472.64" y="206.25" class="st30" width="9.59" height="3.71"/>
          <path :class="{'st29': !on, 'light-on': on}" d="M499.1,213.68h-11.6c-1.37,0-2.49-1.12-2.49-2.49v-6.18c0-1.37,1.12-2.49,2.49-2.49h11.6
            c1.37,0,2.49,1.12,2.49,2.49v6.18C501.59,212.56,500.47,213.68,499.1,213.68z"/>
        </g>
        <g class="valid" @click="setFunction('OFFSET')">
          <rect x="472.64" y="226.89" class="st30" width="9.59" height="3.71"/>
          <path :class="{'st29': !on, 'light-on': on}" d="M499.1,234.33h-11.6c-1.37,0-2.49-1.12-2.49-2.49v-6.18c0-1.37,1.12-2.49,2.49-2.49h11.6
            c1.37,0,2.49,1.12,2.49,2.49v6.18C501.59,233.21,500.47,234.33,499.1,234.33z"/>
        </g>
        <!--
        <g>
          <rect x="472.64" y="247.53" class="st30" width="9.59" height="3.71"/>
          <path class="st29" d="M499.1,254.97h-11.6c-1.37,0-2.49-1.12-2.49-2.49v-6.18c0-1.37,1.12-2.49,2.49-2.49h11.6
            c1.37,0,2.49,1.12,2.49,2.49v6.18C501.59,253.85,500.47,254.97,499.1,254.97z"/>
        </g>
        -->
      </g>
      <g>
      <text transform="matrix(0.95 0 0 1 623.2623 140.1833)" class="st31 st25 st32">Push for Manual Trigger</text>
      </g>
      <text transform="matrix(0.95 0 0 1 631.697 207.6985)" class="st33 st25 st34">BKSP</text>
      <g>
      <g>
        <path class="st13" d="M634.22,210.61l-1.49-0.83l1.49-0.84V210.61z"/>
      </g>
      <rect x="633.47" y="209.54" class="st13" width="6.36" height="0.47"/>
      </g>
      <text transform="matrix(0.95 0 0 1 615.2077 241.6434)" class="st33 st25 st34">Out1</text>
      <text transform="matrix(0.95 0 0 1 672.9541 241.6434)" class="st33 st25 st34">Out2</text>
      <path class="st35" d="M563.84,279.49h-26.63c-2.04,0-3.7-1.67-3.7-3.7V222.5c0-2.04,1.67-3.7,3.7-3.7h26.63
      c2.04,0,3.7,1.67,3.7,3.7v53.28C567.55,277.82,565.88,279.49,563.84,279.49z"/>
      <g>
      <path class="st36" d="M653.09,261.26h-9.08l4.54-7.86L653.09,261.26z M644.71,260.85h7.67l-3.84-6.64L644.71,260.85z"/>
      <g>
        <path class="st36" d="M648.89,259.85c0,0.08-0.01,0.14-0.02,0.2c-0.01,0.05-0.03,0.1-0.07,0.13c-0.03,0.03-0.07,0.06-0.12,0.07
          c-0.05,0.01-0.12,0.02-0.2,0.02c-0.08,0-0.14-0.01-0.2-0.02c-0.05-0.01-0.09-0.04-0.12-0.07c-0.03-0.03-0.05-0.08-0.07-0.13
          c-0.01-0.05-0.02-0.12-0.02-0.2c0-0.08,0.01-0.15,0.02-0.2c0.01-0.05,0.03-0.1,0.07-0.13c0.03-0.03,0.07-0.06,0.12-0.07
          c0.05-0.01,0.12-0.02,0.2-0.02c0.08,0,0.14,0.01,0.2,0.02c0.05,0.01,0.09,0.04,0.12,0.07c0.03,0.03,0.05,0.08,0.07,0.13
          C648.88,259.7,648.89,259.77,648.89,259.85z M648.8,259.01c0,0.02-0.01,0.04-0.02,0.05c-0.01,0.02-0.03,0.03-0.05,0.04
          c-0.02,0.01-0.06,0.02-0.1,0.02c-0.04,0.01-0.09,0.01-0.15,0.01c-0.06,0-0.11,0-0.15-0.01c-0.04-0.01-0.07-0.01-0.1-0.02
          c-0.02-0.01-0.04-0.02-0.05-0.04c-0.01-0.02-0.02-0.03-0.02-0.05l-0.07-2.61c0-0.03,0.01-0.05,0.02-0.07
          c0.01-0.02,0.03-0.04,0.06-0.05c0.03-0.01,0.07-0.02,0.12-0.03c0.05-0.01,0.11-0.01,0.19-0.01c0.08,0,0.14,0,0.19,0.01
          c0.05,0.01,0.09,0.02,0.12,0.03c0.03,0.01,0.05,0.03,0.06,0.05c0.01,0.02,0.02,0.04,0.02,0.07L648.8,259.01z"/>
      </g>
      </g>
      <line class="st37" x1="633.12" y1="263.08" x2="663.98" y2="263.08"/>
      <g>
      <line class="st37" x1="648.55" y1="263.08" x2="648.55" y2="267.02"/>
      <line class="st37" x1="644.82" y1="267.16" x2="652.28" y2="267.16"/>
      <line class="st37" x1="646.35" y1="269.33" x2="650.75" y2="269.33"/>
      <line class="st37" x1="647.48" y1="271.5" x2="649.62" y2="271.5"/>
      </g>
      <g>
      <path class="st16" d="M602.31,262.87c0-9.39,7.61-17.01,17.01-17.01s17.01,7.61,17.01,17.01H602.31z"/>
      <g class="pin">
        <circle class="st38" cx="619.32" cy="262.87" r="14.48"/>
        <radialGradient id="SVGID_1_" cx="619.3198" cy="262.8708" r="11.8519" gradientUnits="userSpaceOnUse">
          <stop  offset="0" style="stop-color:#000000"/>
          <stop  offset="0.2155" style="stop-color:#040404"/>
          <stop  offset="0.4265" style="stop-color:#100F0F"/>
          <stop  offset="0.6356" style="stop-color:#232323"/>
          <stop  offset="0.8424" style="stop-color:#3F3D3D"/>
          <stop  offset="1" style="stop-color:#595757"/>
        </radialGradient>
        <circle class="st39" cx="619.32" cy="262.87" r="11.85"/>
        <circle class="st4" cx="619.32" cy="262.87" r="7.75"/>
        <circle
          :id="pincode + 'C1'"
          class="pin-cover terminal"
          @click="onClick(`${pincode}C1`)"
          cx="619.32" cy="262.87" r="4.21"
        />
      </g>
      </g>
      <g>
      <path class="st17" d="M660.11,262.87c0-9.39,7.61-17.01,17.01-17.01c9.39,0,17.01,7.61,17.01,17.01H660.11z"/>
      <g class="pin">
        <circle class="st38" cx="677.12" cy="262.87" r="14.48"/>
        <radialGradient id="SVGID_2_" cx="677.121" cy="262.8708" r="11.8519" gradientUnits="userSpaceOnUse">
          <stop  offset="0" style="stop-color:#000000"/>
          <stop  offset="0.2155" style="stop-color:#040404"/>
          <stop  offset="0.4265" style="stop-color:#100F0F"/>
          <stop  offset="0.6356" style="stop-color:#232323"/>
          <stop  offset="0.8424" style="stop-color:#3F3D3D"/>
          <stop  offset="1" style="stop-color:#595757"/>
        </radialGradient>
        <circle class="st42" cx="677.12" cy="262.87" r="11.85"/>
        <circle class="st4" cx="677.12" cy="262.87" r="7.75"/>
        <circle
          :id="pincode + 'C2'"
          class="pin-cover terminal"
          @click="onClick(`${pincode}C2`)"
          cx="677.12" cy="262.87" r="4.21"
        />
      </g>
      </g>
      <g>
      <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="208.6876" y1="284.1425" x2="208.6876" y2="304.4706">
        <stop  offset="0" style="stop-color:#9E9E9F"/>
        <stop  offset="0.227" style="stop-color:#BFC0C0"/>
        <stop  offset="0.4151" style="stop-color:#D4D4D5"/>
        <stop  offset="0.5397" style="stop-color:#DBDCDC"/>
        <stop  offset="0.6453" style="stop-color:#D6D6D7"/>
        <stop  offset="0.7808" style="stop-color:#C6C6C7"/>
        <stop  offset="0.9318" style="stop-color:#ACACAD"/>
        <stop  offset="1" style="stop-color:#9E9E9F"/>
      </linearGradient>
      <path class="st43" d="M218.96,301.82h-20.54c-3.94,0-7.16-3.22-7.16-7.16l0,0c0-3.94,3.22-7.16,7.16-7.16h20.54
        c3.94,0,7.16,3.22,7.16,7.16l0,0C226.12,298.59,222.9,301.82,218.96,301.82z"/>
      </g>
      <!-- Power button -->
      <g @click="power()" class="valid">
        <path :class="{'st44': !on, 'on': on}" d="M199.03,300.07c-2.99,0-5.42-2.43-5.42-5.42s2.43-5.42,5.42-5.42h19.32c2.99,0,5.42,2.43,5.42,5.42
          s-2.43,5.42-5.42,5.42H199.03z"/>
        <g>
          <path class="st45" d="M218.35,289.36c2.91,0,5.29,2.38,5.29,5.29s-2.38,5.29-5.29,5.29h-19.32c-2.91,0-5.29-2.38-5.29-5.29
            s2.38-5.29,5.29-5.29H218.35 M218.35,289.11h-19.32c-3.06,0-5.54,2.49-5.54,5.54s2.49,5.54,5.54,5.54h19.32
            c3.06,0,5.54-2.49,5.54-5.54S221.4,289.11,218.35,289.11L218.35,289.11z"/>
        </g>
      </g>
      <g>
      <polygon points="206.31,281.48 206.31,278.88 200.81,278.88 200.81,281.48 199.9,281.48 199.9,282.39 207.23,282.39 207.23,281.48"/>
      <polygon points="216.56,281.48 216.56,280.13 211.06,280.13 211.06,281.48 210.14,281.48 210.14,282.39 217.48,282.39 217.48,281.48"/>
      </g>
      <g>
      <path d="M214.11,269.81H202.7l5.7-9.88L214.11,269.81z M203.58,269.3h9.64l-4.82-8.35L203.58,269.3z"/>
      <g>
        <path d="M208.83,268.04c0,0.1-0.01,0.18-0.02,0.25c-0.01,0.07-0.04,0.12-0.08,0.16c-0.04,0.04-0.09,0.07-0.16,0.09
          c-0.07,0.02-0.15,0.03-0.25,0.03s-0.18-0.01-0.25-0.03c-0.07-0.02-0.12-0.05-0.16-0.09c-0.04-0.04-0.07-0.09-0.08-0.16
          c-0.01-0.07-0.02-0.15-0.02-0.25c0-0.1,0.01-0.19,0.02-0.25c0.02-0.07,0.04-0.12,0.08-0.17c0.04-0.04,0.09-0.07,0.16-0.09
          c0.07-0.02,0.15-0.03,0.25-0.03s0.18,0.01,0.25,0.03c0.06,0.02,0.12,0.05,0.16,0.09c0.04,0.04,0.07,0.1,0.08,0.17
          C208.82,267.85,208.83,267.94,208.83,268.04z M208.72,266.98c0,0.02-0.01,0.05-0.02,0.06c-0.01,0.02-0.03,0.04-0.06,0.05
          c-0.03,0.01-0.07,0.02-0.12,0.03c-0.05,0.01-0.12,0.01-0.19,0.01c-0.08,0-0.14,0-0.19-0.01c-0.05-0.01-0.09-0.02-0.12-0.03
          c-0.03-0.01-0.05-0.03-0.06-0.05s-0.02-0.04-0.02-0.06l-0.09-3.27c0-0.03,0.01-0.06,0.02-0.08c0.01-0.02,0.04-0.04,0.08-0.06
          c0.04-0.02,0.09-0.03,0.15-0.03c0.06-0.01,0.14-0.01,0.24-0.01c0.1,0,0.18,0.01,0.24,0.01c0.06,0.01,0.11,0.02,0.15,0.04
          c0.04,0.02,0.06,0.03,0.08,0.06c0.02,0.02,0.02,0.05,0.02,0.08L208.72,266.98z"/>
      </g>
      </g>
      <circle class="st46" cx="203.56" cy="275.15" r="2.08"/>
      <g>
      <path d="M213.42,276.33h0.87v0.9h-0.87V276.33z M214.26,274.19l-0.22,1.79h-0.39l-0.21-1.79v-1.12h0.82V274.19z"/>
      </g>
      <!-- Sine Dial -->
      <g class="valid" @click="showSineGraph()">
        <g>
          <path :class="{'st15': !on, 'light-on': on}" d="M258.15,301.9h-10.94c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
            c3.58,0,6.51,2.93,6.51,6.51v0C264.66,298.97,261.73,301.9,258.15,301.9z"/>
          <path class="st47" d="M247.2,297.33c0,0,1.13-3.42,2.79-3.42c1.66,0,2.32,2.11,2.32,2.11s1.37,3.11,3.42,0l1.9-2.63"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 247.4509 286.1425)" class="st33 st25 st48">Sine</text>
        </g>
      </g>
      <!-- Squre Dial -->
      <g class="valid" @click="showSquareGraph()">
        <g>
          <path :class="{'st15': !on, 'light-on': on}" d="M297.79,301.9h-10.94c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
              c3.58,0,6.51,2.93,6.51,6.51v0C304.31,298.97,301.37,301.9,297.79,301.9z"/>
          <polyline class="st47" points="286.99,295.1 286.99,293.79 292.36,293.79 292.36,296.99 297.66,296.99 297.66,295.77"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 283.5945 286.1425)" class="st33 st25 st48">Square</text>
        </g>
      </g>
      <!-- Ramp(Triangle) Dial -->
      <g class="valid" @click="showTriGraph()">
        <g>
          <path :class="{'st15': !on, 'light-on': on}" d="M337.44,301.9H326.5c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
            c3.58,0,6.51,2.93,6.51,6.51v0C343.95,298.97,341.02,301.9,337.44,301.9z"/>
          <polyline class="st47" points="326.75,295.89 328.45,293.63 336.03,297.15 337.18,295.39"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 324.6794 286.1425)" class="st33 st25 st48">Triangle</text>
        </g>
      </g>
      <!-- Pulse -->
      <g class="invalid">
        <g>
          <path class="st15" d="M377.08,301.9h-10.94c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
            c3.58,0,6.51,2.93,6.51,6.51v0C383.59,298.97,380.66,301.9,377.08,301.9z"/>
          <polyline class="st47" points="366.55,296.83 367.98,296.83 367.98,293.95 370.35,293.95 370.35,296.83 376.66,296.83"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 365.0276 286.1425)" class="st33 st25 st48">Pulse</text>
        </g>
      </g>
      <!-- Arb Dial -->
      <g class="invalid">
        <g>
          <path class="st15" d="M416.72,301.9h-10.94c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
            c3.58,0,6.51,2.93,6.51,6.51v0C423.23,298.97,420.3,301.9,416.72,301.9z"/>
          <path class="st47" d="M405.88,295.35c0,0,0.87-1.78,1.7-1.78c0.83,0,2.41,2.49,2.41,2.49s1.38,2.45,2.29,0.2s1.74-0.57,1.74-0.57
            s0.91,2.19,2.61-1.44"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 406.9036 286.1425)" class="st33 st25 st48">Arb</text>
        </g>
      </g>
      <!-- Noise Dial -->
      <g class="invalid">
        <g>
          <path class="st15" d="M456.36,301.9h-10.94c-3.58,0-6.51-2.93-6.51-6.51v0c0-3.58,2.93-6.51,6.51-6.51h10.94
            c3.58,0,6.51,2.93,6.51,6.51v0C462.88,298.97,459.95,301.9,456.36,301.9z"/>
          <polyline class="st47" points="446.16,295.31 447.34,294.05 448.29,296.14 449.83,292.39 450.74,298.39 452.16,294.6 453.26,296.85 454.77,294.09 455.63,295.79"/>
        </g>
        <g>
          <text transform="matrix(0.95 0 0 1 443.9958 286.1425)" class="st33 st25 st48">Noise</text>
        </g>
      </g>
      <!-- JSX Graph -->
      <g v-if="on">
        <foreignObject x="222" y="180" width="125" height="85">
          <jsx-graph :graphid="'fggraph' + number" :styling="{width: 120, height: 80, background: ''}"/>
        </foreignObject>
        <text transform="matrix(1 0 0 1 255 260)" class="mode"> Type : {{ info.graph.type }} </text>
        <text transform="matrix(1 0 0 1 240 190)" class="mode"> Period : {{ graphPeriod }} {{ info.graph.unit }}</text>
      </g>
      <!-- Cursor -->
      <text v-if="on" :transform="cursorPos" class="cursor"> ◀︎ </text>
      <!-- Amp/Offest -->
      <g v-if="on">
        <text transform="matrix(1 0 0 1 355 190)" class="mode"> Amplitude </text>
        <text transform="matrix(1 0 0 1 355 210)" class="mode"> {{ info.amp.val }} {{ info.amp.unit }}</text>
        <text transform="matrix(1 0 0 1 360 235)" class="mode"> Offset </text>
        <text transform="matrix(1 0 0 1 365 255)" class="mode"> {{ info.offset.val }} {{ info.offset.unit }} </text>
      </g>
      <!-- Functions Menu -->
      <g v-if="menu && on">
        <rect x="431" y="142" width="40" height="131" rx="3" ry="3" style="fill:#3b4475"/>
        <g>
          <rect
            :class="{'st1': functions !== 'FREQ', 'toggle': functions === 'FREQ' }"
            x="437" y="160" width="30" height="20" rx="5" ry="5"/>
          <text class="st9" transform="matrix(1 0 0 1 442 172)"> FREQ </text>
        </g>
        <g>
          <rect
            :class="{'st1': functions !== 'AMPL', 'toggle': functions === 'AMPL' }"
            x="437" y="185" width="30" height="20" rx="5" ry="5"/>
          <text class="st9" transform="matrix(1 0 0 1 442 198)"> AMPL </text>
        </g>
        <g>
          <rect
            :class="{'st1': functions !== 'OFFSET', 'toggle': functions === 'OFFSET' }"
            x="437" y="210" width="30" height="20" rx="5" ry="5"/>
          <text class="st9" transform="matrix(1 0 0 1 438 223)"> OFFSET </text>
        </g>
        <text class="st1 st9" transform="matrix(1 0 0 1 440 152)"> MENU </text>
      </g>
    </g>
  </g>
</template>

<script>
import JsxGraph from '../../../graph/JSXGraph.vue'
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'
import { graph } from '../../../../mixins/graph.js'

const OVERFLOW = -9999
const FREQ_INIT_VALUE = Number(0.0).toFixed(3)
const AMP_INIT_VALUE = Number(0.0).toFixed(1)

const convertFrequency = function (freq) {
  let unit = 'Hz'
  let val = freq
  if (freq !== 0.0 && freq <= Math.pow(10, -3)) {
    unit = 'mHz'
    val = freq * 1000
  } else if (freq >= Math.pow(10, 3) && freq < Math.pow(10, 6)) {
    unit = 'kHz'
    val = freq / 1000
  } else if (freq >= Math.pow(10, 6) && freq < Math.pow(10, 7)) {
    unit = 'MHz'
    val = freq / 1000000
  } else if (freq >= Math.pow(10, 7)) {
    val = -9999
    unit = 'Hz'
  }
  return { val: val.toFixed(3), unit, freq }
}

const convertAmpl = function (amp) {
  let unit = 'Vpp'
  let val = amp
  if (amp !== 0.0 && amp <= Math.pow(10, -3)) {
    val = amp * 1000
    unit = 'mVpp'
  } else if (amp > 10) {
    val = -9999
    unit = 'Vpp'
  }
  return { val: val.toFixed(1), unit, amp }
}

const convertOffset = function (offset) {
  let unit = 'mV'
  let val = offset
  if (offset < 0.0) {
    val = -9999
    unit = 'mV'
  } else if (offset > 1000.0 && offset < Math.pow(10, 5)) {
    val = offset / 1000.0
    unit = 'V'
  } else if (offset >= Math.pow(10, 5)) {
    val = -9999
    unit = 'mV'
  }
  return { val, unit, offset }
}

const isFreqOutOfRange = function (freq) {
  return freq < 0.0001 || freq > 10000000
}

export default {
  name: 'Functiongen',
  props: ['data'],
  mixins: [pins, graph],
  components: { JsxGraph },
  data () {
    return {
      code: '',
      on: false,
      // properties for a function generator
      inputs: '',
      // properties for displaying on the pannel
      info: {
        ch: 'ch1', // 'ch1' or 'ch2'
        freq: {
          val: FREQ_INIT_VALUE,
          unit: 'Hz' // 'mHz', 'Hz'(default), 'kHz', 'MHz'
        },
        graph: { type: '', t: 1, unit: 's' },
        amp: {
          val: AMP_INIT_VALUE, // 1mVpp ~ 10Vpp
          unit: 'Vpp' // 'mVpp', 'Vpp'(default)
        },
        offset: {
          val: 0,
          unit: 'mV'
        }
      },
      menu: true, // display menu toggle
      functions: 'FREQ', // 'FREQ', 'AMPL', 'OFFSET'
      result: {
        ch1: { freq: 0.0, amp: 1, offset: 0, type: '' },
        ch2: { freq: 0.0, amp: 1, offset: 0, type: '' }
      },
      cursor: {
        ptr: 0,
        x: 0,
        y: 0
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
    const { val, unit } = convertFrequency(this.result.ch1.freq)
    this.info.freq = { val, unit }
  },
  beforeDestroy () {
    if (this.board) this.freeBoard()
  },
  computed: {
    cursorPos () {
      if (this.functions === 'FREQ') {
        return 'matrix(1 0 0 1 405 170)'
      } else if (this.functions === 'AMPL') {
        return 'matrix(1 0 0 1 407 213)'
      } else return 'matrix(1 0 0 1 407 255)'
    },
    graphPeriod () {
      if (Number(this.result[this.info.ch].freq) === 0.0) return 0.0
      const t = 1 / this.result[this.info.ch].freq
      const floating = t.toString().length - t.toString().indexOf('.') - 1
      return t.toFixed(floating)
    }
  },
  methods: {
    onClick (pin) {
      window.event.stopPropagation()
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
    },
    power () {
      window.event.stopPropagation()
      this.on = !this.on
    },
    resetSettings () { // reset all info properties(attributes)
      this.info.ch = 'ch1'
      this.info.freq = { val: FREQ_INIT_VALUE, unit: 'Hz' }
      this.info.graph.type = ''
      this.info.amp = { val: AMP_INIT_VALUE, unit: 'Vpp' }
      this.info.offset = { val: 0, unit: 'mV' }
      this.inputs = ''
      this.functions = 'FREQ'
      this.result = {
        ch1: { freq: 0, amp: 0, offset: 0, type: '' },
        ch2: { freq: 0, amp: 0, offset: 0, type: '' }
      }
    },
    displayMenu () {
      window.event.stopPropagation()
      this.menu = !this.menu
    },
    setFunction (func) {
      window.event.stopPropagation()
      this.functions = func
      this.inputs = ''
    },
    showSineGraph () {
      window.event.stopPropagation()
      this.drawGraph('sine')
    },
    showSquareGraph () {
      window.event.stopPropagation()
      this.drawGraph('square')
    },
    showTriGraph () {
      window.event.stopPropagation()
      this.drawGraph('tri')
    },
    drawGraph (type = '') {
      if (!this.on) return
      this.result[this.info.ch].type = this.info.graph.type = type
      if (this.board) this.freeBoard()
      this.setGraphAttribute(false, false, false)
      this.setFunctionGraphData({ freq: 2, type })
      this.initBoard('double', 'fggraph' + this.number)
      this.drawGraphByType(type, 'ch1')
    },
    changeChannel () {
      window.event.stopPropagation()
      if (!this.on) return
      this.info.ch = this.info.ch === 'ch1' ? 'ch2' : 'ch1'
      const freq = convertFrequency(this.result[this.info.ch].freq)
      this.info.freq = { val: freq.val, unit: freq.unit }
      const amp = convertAmpl(this.result[this.info.ch].amp)
      this.info.amp = { val: amp.val, unit: amp.unit }
      const offset = convertOffset(this.result[this.info.ch].offset)
      this.info.offset = { val: offset.val, unit: offset.unit }
      this.info.graph.type = this.result[this.info.ch].type
      this.drawGraph(this.info.graph.type)
    },
    moveFloating (mov) {
      window.event.stopPropagation()
      this.cursor.ptr += mov
      const f = this.result[this.info.ch].freq
      if (isFreqOutOfRange(f)) {
        this.cursor.ptr = 0
        this.result[this.info.ch].freq = 0.0
        this.info.freq.val = FREQ_INIT_VALUE
        this.info.freq.unit = 'Hz'
        this.inputs = ''
        return
      }
      const cal = f * Math.pow(10, mov)
      const { val, unit, freq } = convertFrequency(cal)
      this.info.freq = { val, unit }
      this.result[this.info.ch].freq = freq
    },
    pressDial (dial) {
      window.event.stopPropagation()
      switch (this.functions) {
        case 'FREQ':
          this.setFrequency(dial)
          break
        case 'AMPL':
          this.setAmpl(dial)
          break
        case 'OFFSET':
          this.setOffset(dial)
          break
      }
      this.updateFGdata()
    },
    setFrequency (dial) {
      if (dial === 'RESET') {
        this.info.freq.val = FREQ_INIT_VALUE
        this.info.freq.unit = 'Hz'
        this.result[this.info.ch].freq = FREQ_INIT_VALUE
        this.cursor.ptr = 0
        this.inputs = ''
        return
      } else if (dial === '.') {
        if (this.inputs.indexOf('.') > -1) return
      }
      this.inputs += dial
      let { val, unit, freq } = convertFrequency(Number(this.inputs))
      this.info.freq.unit = unit
      if (val === OVERFLOW.toFixed(3)) {
        this.inputs = ''
        freq = val = 0
      }
      this.result[this.info.ch].freq = freq
      this.info.freq = { val, unit }
    },
    setAmpl (dial) {
      if (dial === 'RESET') {
        this.info.amp.val = AMP_INIT_VALUE
        this.info.amp.unit = 'Vpp'
        this.result[this.info.ch].amp = AMP_INIT_VALUE
        this.cursor.ptr = 0
        this.inputs = ''
        return
      } else if (dial === '.') {
        if (this.inputs.indexOf('.') > -1) return
      }
      this.inputs += dial
      let { val, unit, amp } = convertAmpl(Number(this.inputs))
      this.info.amp.unit = unit
      if (val === OVERFLOW.toFixed(3)) {
        this.inputs = ''
        amp = val = 0
      }
      this.result[this.info.ch].amp = amp
      this.info.amp = { val, unit }
    },
    setOffset (dial) {
      if (dial === 'RESET') {
        this.info.offset.val = 0.0
        this.info.offset.unit = 'Vpp'
        this.result[this.info.ch].offset = 0
        this.cursor.ptr = 0
        this.inputs = ''
        return
      } else if (dial === '.') {
        if (this.inputs.indexOf('.') > -1) return
      }
      this.inputs += dial
      let { val, unit, offset } = convertOffset(Number(this.inputs))
      this.info.offset.unit = unit
      if (val === OVERFLOW) {
        this.inputs = ''
        offset = val = 0.0.toFixed(3)
      }
      this.result[this.info.ch].offset = offset
      this.info.offset = { val, unit }
    },
    updateFGdata () {
      store.state.elct.using.FG[this.data.id][this.info.ch] = this.result[this.info.ch]
    }
  }
}
</script>

<style lang="scss" scoped>
g.selected {
  path.tool-border{
    stroke-width: 2px;
    stroke: #ff6f61;
  }
}
.pin-cover {
  display: block;
  stroke: none;
  fill: #816417;
}
.pin:hover {
  .pin-cover {
    cursor: pointer;
    stroke-width: 1px;
    stroke: black;
    fill: #ff6f61;
  }
  .disable {
    cursor: not-allowed;
  }
}
.on {
  fill: #ff6f61;
  stroke:#231815;
  stroke-width:0.5;
}
.valid .light-on {
    fill: #c2ff61;
}
.toggle {
  fill: #ff6f61;
  font-weight: bold;
}
.toggle:hover,.valid:hover {
  cursor: pointer;
}
.invalid:hover {
  cursor: not-allowed;
}
g.display {
  text{
    fill: #248D3A;
    font-size: 30px;
  }
  text.type {
    font-size: 25px;
    font-style: italic;
  }
  text.range {
     font-size: 22px;
    font-style: italic;
  }
}

text.mode {
  fill: white;
  font-size: 12px;
}

.cursor {
  fill: yellow;
  animation: blink 1s infinite;
}

@keyframes blink{
  50% {
    opacity: 0;
  }
}

.highlight {
  -webkit-filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
  filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
}
.tool-border, .st0 {fill:#D6D6D5;}
.st1{fill:#CACAC9;}
.st2{fill:#D6D6D5;stroke:#ADABA9;stroke-miterlimit:10;}
.st3{fill:#AEB6B3;stroke:#7F7F7E;stroke-width:0.5;stroke-miterlimit:10;}
.st4{fill:#EEEEEF;}
.st5{fill:none;stroke:#CACAC9;stroke-width:0.75;stroke-miterlimit:10;}
.st6{fill:#3E4250;}
.st7{fill:#FFFFFF;}
.st8{font-family:'Helvetica75-Bold';}
.st9{font-size: 8px;}
.st10{font-size:8px;}
.st11{font-size:3.7272px;}
.st12{fill:#EEEEEF;stroke:#CCCCCB;stroke-width:0.5;stroke-miterlimit:10;}
.st13{fill:#1B1B11;}
.st14{font-size:5.7685px;}
.st15{fill:#D3EEEF;stroke:#CCCCCB;stroke-width:0.5;stroke-miterlimit:10;}
.st16{fill:#FBF3A2;}
.st17{fill:#59D2FF;}
.st18{fill:#4C4C4C;stroke:#9E9E9F;stroke-width:0.5;stroke-miterlimit:10;}
.st19{fill:#9E9E9F;}
.st20{fill:#9A9A96;}
.st21{fill:#5D5D5A;}
.st22{font-family:'TimesNewRomanPS-BoldMT';}
.st23{font-size:11.4562px;}
.st24{fill:#3B1B83;}
.st25{font-family:'Helvetica-Light';}
.st26{font-size:4.1808px;}
.st27{fill:none;stroke:#ADABA9;stroke-width:0.75;stroke-miterlimit:10;}
.st28{fill:#383834;stroke:#ADABA9;stroke-width:3;stroke-miterlimit:10;}
.st29{fill:#F5F4F4;stroke:#C4C4C3;stroke-width:0.75;stroke-miterlimit:10;}
.st30{fill:#FDF8ED;stroke:#ADABA9;stroke-width:0.5;stroke-miterlimit:10;}
.st31{fill:#2F2F2B;}
.st32{font-size:5px;}
.st33{fill:#1B2122;}
.st34{font-size:4.1865px;}
.st35{fill:none;stroke:#989AA1;stroke-width:0.75;stroke-miterlimit:10;}
.st36{fill:#989AA1;}
.st37{fill:#ADABA9;stroke:#989AA1;stroke-width:0.5;stroke-miterlimit:10;}
.st38{fill:#ADABA9;stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st39{fill:url(#SVGID_1_);stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st40{fill:#816417;stroke:#595757;stroke-miterlimit:10;}
.st41{fill:#3E3A39;}
.st42{fill:url(#SVGID_2_);stroke:#DBDCDC;stroke-width:0.5;stroke-miterlimit:10;}
.st43{fill:url(#SVGID_3_);}
.st44{fill:#6CAB86;}
.st45{fill:#7F7F7E;}
.st46{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}
.st47{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}
.st48{font-size:6px;}
</style>
